// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Sp-z","slideIn":"Tp-z"};